import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import React from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: Store4ColumnsContentStyles;
}

export interface Store4ColumnsContentStyles {
    container?: GridContainerProps;
    gridItem?: GridItemProps;
}

export const store4ColumnsContentStyles: Store4ColumnsContentStyles = {
    container: {
        gap: 25,
        css: css`
            margin-top: 25px;
            margin-bottom: 55px;
        `,
    },
    gridItem: {
        width: [12, 6, 6, 3, 3],
    },
};

const Store4ColumnsContent = ({ id, extendedStyles }: OwnProps) => {
    const [styles] = React.useState(() => mergeToNew(store4ColumnsContentStyles, extendedStyles));

    const SectionTitle = getWidgetComponent("ProductDetails/ProductDetailsSectionTitle");

    return (
        <>
            <SectionTitle sectionTitleValue={translate("Corporation")} />
            <GridContainer {...styles.container}>
                <GridItem {...styles.gridItem}>
                    <Zone zoneName="Column1" contentId={id} />
                </GridItem>
                <GridItem {...styles.gridItem}>
                    <Zone zoneName="Column2" contentId={id} />
                </GridItem>
                <GridItem {...styles.gridItem}>
                    <Zone zoneName="Column3" contentId={id} />
                </GridItem>
                <GridItem {...styles.gridItem}>
                    <Zone zoneName="Column4" contentId={id} />
                </GridItem>
            </GridContainer>
        </>
    );
};

const store4ColumnsContent: WidgetModule = {
    component: Store4ColumnsContent,
    definition: {
        group: "Common",
        isSystem: true,
    },
};

export default store4ColumnsContent;
